<template>
  <div>
    <Loading v-if="loading" />
    <div v-if="!loading">
      <b-row>
        <b-col md="8">
          <h2 class="page-title">
            Leave
          </h2>
        </b-col>
      </b-row>
      <b-card title="Apply For Leave">
        <b-form @submit.prevent="submitForm">
          <b-row v-if="userIsSuperAdmin">
            <b-col md="6" class="checkbox">
              <b-form-group>
                <b-form-checkbox v-model="applyForAnotherUser"
                  >Apply for another User?</b-form-checkbox
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="applyForAnotherUser">
            <b-col md="6">
              <b-form-group label="User">
                <b-form-select
                  v-model="existingUserId"
                  class="mb-2 disabled"
                  autocomplete="off"
                  readonly
                  :options="userOptions"
                >
                  <template v-slot:first>
                    <option disabled :value="null">
                      -- Please Select User --
                    </option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group label="Type">
                <b-form-select
                  v-model="type"
                  :options="options"
                  class="mb-2"
                  @change="selectionChanged"
                >
                  <template v-slot:first>
                    <option :value="null" disabled
                      >-- Please select a Type --</option
                    >
                  </template>
                </b-form-select>
              </b-form-group>
              <b-form-group label="First Day of Leave">
                <v-date-picker
                  v-model="dateFrom"
                  :first-day-of-week="1"
                  :show-current="true"
                  :masks="{ input: 'YYYY/MM/DD' }"
                >
                </v-date-picker>
                <transition name="fade">
                  <b-alert
                    v-if="false"
                    show
                    variant="danger"
                    class="error col-md-6 mt-1"
                  ></b-alert>
                </transition>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group v-if="!hideReason" label="Reason">
                <b-form-input
                  v-model="reason"
                  class="mb-2"
                  fade="true"
                  autocomplete="off"
                  label="Reason"
                  placeholder="Enter Reason"
                >
                </b-form-input>
                <transition name="fade">
                  <b-alert
                    v-if="false"
                    show
                    variant="danger"
                    class="error col-md-6 mt-1"
                  ></b-alert>
                </transition>
              </b-form-group>
              <b-form-group label="Last Day of Leave" :class="dynamicDateClass">
                <v-date-picker
                  v-model="dateTo"
                  :first-day-of-week="1"
                  :show-current="true"
                  :masks="{ input: 'YYYY/MM/DD' }"
                >
                </v-date-picker>

                <transition name="fade">
                  <b-alert
                    v-if="false"
                    show
                    variant="danger"
                    class="error col-md-6 mt-1"
                  ></b-alert>
                </transition>
              </b-form-group>
              <b-button
                type="submit"
                class="submit-btn"
                variant="primary"
                :disabled="submitDisabled"
                >Submit</b-button
              >
            </b-col>
          </b-row>
        </b-form>
        <b-row>
          <div class="disclaimer">
            This request is submitted for approval and is subject to rejection
          </div>
        </b-row>
        <div
          v-if="submitDisabled"
          style="width: 102%; height: 102%; left: -1%; top: -1%; background-color: rgba(250, 250, 250, 0.75); position: absolute; filter: blur(8px)"
          class="d-flex justify-content-center overlay"
        ></div>
        <div
          v-if="submitDisabled"
          style="width: 102%; height: 102%; left: 0%; top: 0%;position: absolute;"
          class="d-flex justify-content-center"
        >
          <div class="d-flex flex-column justify-content-center">
            <div
              class="spinner spinner-primary m-3"
              style="background-color: rgba(170, 170, 170, 0.5) !important; width: 2rem; height: 2rem; display: block"
            ></div>
            <strong
              class="text-left font-weight-extrabold pt-2"
              style="left: -5%; display: block;"
              >Hold Tight...</strong
            >
          </div>
        </div>
      </b-card>
      <b-row v-if="false" class="upcoming-leave">
        <b-card title="Upcoming Leave">
          <div></div>
        </b-card>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "ApplyLeave",
  apollo: {
    existingUser: {
      query: require("@/graphql/Account/GetUser.gql"),
      variables() {
        return {
          userId: this.$route.params.userId
        }
      },
      skip() {
        return !this.$route.params.userId
      },
      update(data) {
        //Admin is adding leave for this user
        if (!data.user) {
          this.$toasted.error("User not found")
          this.$router.back()
        }
        this.existingUserId = data.user.id
        this.applyForAnotherUser = true
        return data.user
      }
    },
    users: {
      query: require("@/graphql/Account/GetUsers.gql"),
      update(data) {
        setTimeout(() => {
          this.constructing = true
          this.$nextTick(() => {
            this.loading = false
          })
        }, 500)
        return data.users.removeUnassigned().sortBy(x => x.firstName)
      }
    }
  },
  data() {
    return {
      loading: true,
      reason: "",
      dateFrom: "",
      dateTo: "",
      type: null,
      options: [],
      hideReason: false,
      existingUserId: null,
      applyForAnotherUser: false,
      submitDisabled: false
    }
  },
  computed: {
    ...mapGetters({
      getCurrentUser: "getCurrentUser"
    }),
    dynamicDateClass() {
      return this.type === "WorkFromHome" ? "margin-top-75" : ""
    },
    userIsSuperAdmin() {
      return (
        this.getCurrentUser &&
        this.getCurrentUser.roles &&
        this.getCurrentUser.roles.includes("Super Admin")
      )
    },
    userOptions() {
      return (
        this.users?.map(x => {
          return {
            value: x.id,
            text: this.$utils.getUserName(x)
          }
        }) ?? []
      )
    }
  },
  created() {
    //TESTING
    // if (process.env.NODE_ENV == "development") {
    //   this.reason = "test"
    //   this.dateFrom = new Date()
    //   this.dateTo = new Date()
    //   this.type = "Leave"
    // }
    this.options = [
      // { value: "WorkFromHome", text: "Work From Home" },
      { value: "Leave", text: "Leave" },
      { value: "SickLeave", text: "Sick Leave" },
      { value: "StudyLeave", text: "Study Leave" }
    ]
    this.loading = false
  },
  methods: {
    /**
     * Validates input and saves leave entry
     */
    submitForm() {
      if (!this.existingUserId && this.applyForAnotherUser)
        return this.$toasted.error(
          "Please select the user you are applying for"
        )
      if (!this.reason && this.type !== "WorkFromHome") {
        this.$toasted.error("Please specify a Reason")
        return
      }
      if (!this.type) {
        this.$toasted.error("Please specify a Type")
        return
      }
      if (!this.dateFrom) {
        this.$toasted.error("Please specify your First Day of Leave")
        return
      }
      if (!this.dateTo) {
        this.$toasted.error("Please specify your Last Day of Leave")
        return
      }
      if (this.dateFrom > this.dateTo) {
        this.$toasted.error(
          "First day of leave can't be after last day of leave"
        )
        return
      }
      if (this.dateFrom < this.formattedDate(0, -30)) {
        this.$toasted.error("First day of leave can't be older than 30 days")
        return
      }

      this.submitDisabled = true

      this.addLeave()
        .then(async () => {
          this.submitSuccess()
        })
        .catch(error => {
          this.submitDisabled = false
          this.submitFailure(error)
        })
        .finally(() => {
          this.clearForm()
          //If admin added leave send them back to manage users page
          if (this.existingUserId) this.$router.push("/Users/ManageUsers")
        })
    },
    /**
     * Hides reason textbox if leave type is "WorkFromHome"
     */
    selectionChanged() {
      if (this.type == "WorkFromHome") this.hideReason = true
      else this.hideReason = false
    },
    submitSuccess() {
      this.$toasted.success(`Leave Submitted Successfully`)
    },
    /**
     *
     * @param error
     */
    submitFailure(error) {
      this.$toasted.error(`Error Submitting Leave ${error} `)
    },
    clearForm() {
      this.dateTo = null
      this.dateFrom = null
      this.type = null
      this.reason = null
      this.submitDisabled = false
    },
    /**
     * Attempts to save leave request through API - throws error if unsuccessful
     * @returns {Promise<unknown>}
     */
    async addLeave() {
      return await new Promise((resolve, reject) => {
        this.$apollo
          .mutate({
            mutation: require("@/graphql/Leave/ApplyForLeave.gql"),
            variables: {
              leave: {
                from: this.$utils.getDate(this.dateFrom),
                to: this.$utils.getDate(this.dateTo),
                reason:
                  this.type == "WorkFromHome"
                    ? "Working From Home"
                    : this.reason,
                //Needed for admins to manually add leave
                userId: this.existingUserId ?? this.getCurrentUser.id,
                type: this.type
              }
            }
          })
          .then(() => {
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    formattedDate(monthIncrement, dayIncrement) {
      let today = new Date()

      if (monthIncrement !== 0) {
        today = new Date(today.setMonth(today.getMonth() + monthIncrement))
      }
      if (dayIncrement !== 0) {
        today = new Date(today.setDate(today.getDate() + monthIncrement))
      }

      return today.toISOString().substring(0, 10)
    }
  }
}
</script>

<style scoped>
.submit-btn {
  margin-top: 15px;
  float: right;
}

.margin-top-75 {
  margin-top: 75px;
}

.form-control {
  background-color: white !important;
}

.disclaimer {
  font-style: italic;
  color: lightcoral;
  margin-left: 1rem;
}

.upcoming-leave {
  margin-left: 0.1rem;
  margin-top: 1rem;
  width: 100%;
}
.disabled {
  color: grey !important;
}
.checkbox {
  padding: 0.3rem 1rem;
}
</style>

<style>
.disabled :focus {
  border: inherit !important;
  color: inherit !important;
  background-color: inherit !important;
  border-color: unset !important;
  outline: inherit !important;
  -webkit-box-shadow: inherit !important;
  box-shadow: inherit !important;
}
</style>
